import React from 'react';
import Header from './layout/Header';
import Footer from './layout/Footer';

import Home from './pages/Home';
import About from './pages/About';
import Books from './pages/Books';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import TermsAndConditions from './pages/TermsAndConditions';
import BookDetails from './pages/BookDetails';
import AuthorDetails from './pages/AuthorDetails';
import Faq from './pages/Faq';
import BecomePublisher from './pages/BecomePublisher';

const routes = [
    {
        path: '/',
        component: Home,
        header: Header,
        footer: Footer,
        auth: false,
        innerBanner: null,
    },
    {
        path: '/about',
        component: About,
        header: Header,
        footer: Footer,
        auth: false,
        innerBanner: null,
    },
    {
        path: '/books',
        component: Books,
        header: Header,
        footer: Footer,
        auth: false,
        innerBanner: null,
    },
    {
        path: '/faq',
        component: Faq,
        header: Header,
        footer: Footer,
        auth: false,
        innerBanner: null,
    },
    {
        path: '/contact',
        component: Contact,
        header: Header,
        footer: Footer,
        auth: false,
        innerBanner: null,
    },
    {
        path: '/book-details',
        component: BookDetails,
        header: Header,
        footer: Footer,
        auth: false,
        innerBanner: null,
    },
    {
        path: '/privacy',
        component: Privacy,
        header: Header,
        footer: Footer,
        auth: false,
        innerBanner: null,
    },
    {
        path: '/t&c',
        component: TermsAndConditions,
        header: Header,
        footer: Footer,
        auth: false,
        innerBanner: null,
    },
    {
        path: '/author',
        component: AuthorDetails,
        header: Header,
        footer: Footer,
        auth: false,
        innerBanner: null,
    },
    {
        path: '/become-publisher',
        component: BecomePublisher,
        header: Header,
        footer: Footer,
        auth: false,
        innerBanner: null,
    }
];

export default routes;